export const WORK_ORDER_DETAIL_PAGE_EVENT = "Work Order Detail Page";
export const WORK_ORDER_DETAIL_PAGE_STEPS = {
  ENTRY: "Entry",
  MARK_AS_COMPLETED_SUCCESS: "Marked as completed success",
  MARK_AS_COMPLETED_FAILED: "Marked as completed failed"
};
